import { useEffect } from 'react';
import { useLocation } from '@jira/navigation-apps__routing-hooks/src/useLocation.tsx';
import { useNavigateBack } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-back-button/src/controllers/navigate-back-context/index.tsx';
import { useIsNonRedirectRoute } from '@jira/navigation-apps__sidebar-nav4-sidebar-selector/src/ui/regular/index.tsx';
import { useIsConnectAppActive as useIsProjectSettingsConnectAppActive } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-project-common/src/controllers/is-connect-app-active/index.tsx';

/**
 * Improved implementation: derives the URL string during render so the effect dependency
 * is a stable primitive. The effect only fires when the actual URL string changes,
 * not whenever the location object reference changes.
 */
export function useSaveCurrentContentSidebarRoute(): void {
	const { saveCurrentRoute } = useNavigateBack();
	const location = useLocation();
	const { isActive: isProjectSettingsConnectAppActive } = useIsProjectSettingsConnectAppActive();
	const isNonRedirectRoute = useIsNonRedirectRoute();

	// Derive the URL string during render — stable primitive string for the dep array.
	// Avoids spurious effect executions when the location object reference changes
	// but the actual URL has not.
	const url = `${location.pathname}${location.search}${location.hash}`;

	useEffect(() => {
		// NOTE: We need to AVOID saving the route if we're on a connect app...
		if (isNonRedirectRoute && !isProjectSettingsConnectAppActive) {
			saveCurrentRoute(url);
		}
	}, [isNonRedirectRoute, isProjectSettingsConnectAppActive, url, saveCurrentRoute]);
}
